<label class="content-label">Content</label>
<input class="content-input form-control" type="text" [(ngModel)]="model.content" />
